export type ReviewEvent =
  | { surface: "widget"; step: "shown" | "pressed" }
  | { surface: "popup"; step: "shown" | "sent_to_trustpilot" | "kept_internal" }
  | { surface: "popup"; step: "rated"; rating: number };

/**
 * GD-141 — one step of the review pop-up or widget, saved by global-api
 * (GAPI-1065) through each app's `app/api/review-event`; the API files it under
 * the purchase's own business, so the PDF Member Zone's steps count as PDF.
 * Never awaited and never throws: a lost event must not change what the member
 * sees.
 */
export function trackReview(applicationId: string, event: ReviewEvent) {
  fetch("/api/review-event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ applicationId, ...event }),
    // The member may close the tab right after rating.
    keepalive: true,
  }).catch(() => {});
}
